export default "__VITE_ASSET__k7jcM605__"